import api from "./api";

const Gestion = {
     GestionAPI(datos) {
      const config = {
        headers: {
          'Content-Type': 'application/json'
        },
        params: datos
      };
      return api.get(`/gestion_marcacion/listar_gestion`, config)
    },
    async listar(filtroNombre?: string) {
      const params = filtroNombre ? `?ps_nombre=${filtroNombre}` : "";
      return api.get(`punto_servicio/todos${params}`);
    },

    async guardarSalida(datos) {
      const config = {
        headers: {
          'Content-Type': 'application/json'
        }
      };
      return api.post(`/gestion_marcacion/generar_marcacion`, datos, config);
    },
    async guardarEntrada(datos) {
      const config = {
        headers: {
          'Content-Type': 'application/json'
        }
      };
      return api.post(`/gestion_marcacion/generar_marcacion`, datos, config);
    },
    async modificarMarcacion(datos) {
      const config = {
        headers: {
          'Content-Type': 'application/json'
        }
      };
      return api.post(`/gestion_marcacion/modificar_marcacion`, datos, config);
    },
    async emparejarMarcaciones(datos) {
      const config = {
        headers: {
          'Content-Type': 'application/json'
        }
      };
      return api.post(`/gestion_marcacion/emparejar_marcaciones`, datos, config);
    },
    async guardarSupera(datos) {
      const config = {
        headers: {
          'Content-Type': 'application/json'
        }
      };
      return api.post(`/gestion_marcacion/gestionar_supera`, datos, config);
    },
    async gestionarSinSalida(datos) {
      const config = {
        headers: {
          'Content-Type': 'application/json'
        }
      };
      return api.post(`/gestion_marcacion/generar_lapiz`, datos, config);
    },
    async gestionarSinEntrada(datos) {
      const config = {
        headers: {
          'Content-Type': 'application/json'
        }
      };
      return api.post(`/gestion_marcacion/generar_lapiz`, datos, config);
    },
    async traerMarcaciones(datos) {
      const config = {
        headers: {
          'Content-Type': 'application/json'
        },
        params: datos
      };
      return api.get(`/gestion_marcacion/marcaciones`, config);
    },
    async traerHorasProcesadas(datos) {
      const config = {
        headers: {
          'Content-Type': 'application/json'
        },
        params: datos
      };
      return api.get(`/gestion_marcacion/horas_procesadas`, config);
    },

    // Reset acotado para que un caso SIN-ASIGNACION vuelva a reprocesarse automáticamente.
    // En backend borra HNP y deja Estado=NULL en las marcaciones HE/HS asociadas.
    async resetearSinAsignacion(referencia_id: number | string) {
      const config = {
        headers: {
          'Content-Type': 'application/json'
        }
      };
      return api.post(`/gestion_marcacion/resetear_sin_asignacion`, { referencia_id }, config);
    },
  }
  

export default Gestion;